document.addEventListener('DOMContentLoaded', function() {
    const heroContainer = document.querySelector('.js-hero');
    if (!heroContainer) return;

    const videoWrapper = heroContainer.querySelector('.c-hero__video');
    const videoElement = videoWrapper ? videoWrapper.querySelector('video') : null;

    if (videoElement) {
        const desktopSrc = videoElement.getAttribute('data-desktop-src');
        const mobileSrc = videoElement.getAttribute('data-mobile-src');

        if (desktopSrc && mobileSrc) {
            const mediaQuery = window.matchMedia('(min-width: 768px)');
            const videoType = 'video/mp4';

            function setVideoSource(query) {
                let videoSrc = query.matches ? desktopSrc : mobileSrc;

                if (videoElement.querySelector(`source[src="${videoSrc}"]`)) {
                    return;
                }

                videoElement.innerHTML = `<source src="${videoSrc}" type="${videoType}">`;
                videoElement.load();

                const playPromise = videoElement.play();
                if (playPromise !== undefined) {
                    playPromise.then(() => {}).catch(error => {
                        console.warn('Advertencia: La reproducción automática...');
                    });
                }
            }

            setVideoSource(mediaQuery);
            mediaQuery.addEventListener('change', setVideoSource);
        }
    }

    const scrollButton = heroContainer.querySelector('.js-scroll-down');
    const lenisInstance = window.scroll ? window.scroll.lenis : null;

    if (scrollButton && lenisInstance) {
        scrollButton.addEventListener('click', function(event) {
            event.preventDefault();

            // 1. Inicializamos un iterador con el primer hermano
            let currentNode = heroContainer.nextElementSibling;

            // Inicializamos targetElement a null (será nuestro destino final)
            let targetElement = null;

            // 2. Iteramos hasta que currentNode sea null (fin de los hermanos)
            while (currentNode) {

                // 3. Verificamos si es un elemento de contenido válido
                if (currentNode.nodeType === 1) {
                    const tagName = currentNode.tagName.toLowerCase();

                    if (tagName !== 'script' && tagName !== 'link') {
                        // ¡Encontrado! Asignamos a targetElement y salimos.
                        targetElement = currentNode;
                        break;
                    }
                }

                // 4. Si no es válido, avanzamos al siguiente hermano
                currentNode = currentNode.nextElementSibling;
            }

            // 5. Si se encontró un destino, ejecutamos Lenis
            if (targetElement) {
                lenisInstance.scrollTo(targetElement, {
                    duration: 1.2,
                    easing: (t) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t)
                });
            }
        });
    }
});
